export enum FeatureFlagKeys {
    ShowProfileModal = 'photo_showprofilemodal',
    ShowSnowLogo = 'photo_show_snow_logo',
    ShowBookingsCalendarPage = 'photo_showbookingscalendarpage',
    ReorderImages = 'photo_reorder_images',
    BrokerAgentOrderListV2 = 'photo__brokeragentorderlist_v2',
    CustomerBookingCalendarV2 = 'photo__customerbookingcalendar_v2',
    CloneOrder = 'photo_clone_order',
    ImageEditorImageProcessingV2 = 'photo__imageeditorimageprocessing_v2',
    PhotographerDroneToggle = 'photo_photographer_drone_toggle',
    PublishedNewsForUsers = 'photo_published_news_for_users',
    BrokerSuperSearch = 'photo_broker_super_search',
    CustomerCalendar = 'photo_customer_calendar',
    CreateOrderV2OptIn = 'photo__createorder_v2_optin'
}
